import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import type { SelectItem } from '../../../../../models/select/selectItem';
import { fromCompany } from '../../../../../models/select/selectItem';
import type { Company } from '../../../../../models/companies/company';

type Props = {
  companies: Array<Company>;
  inputName?: string;
  className?: string;
  defaultCompanyId: number | null;
  placeholder?: string;
};

export default function SelectCompaniesView(props: Props) {
  const { companies, inputName, className, defaultCompanyId, placeholder } =
    props;
  const [selectedOption, setSelectedOption] = useState<SelectItem | null>(null);
  const [options] = useState<Array<SelectItem>>(fromCompany(companies));
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- react-select の ref 型が定まらないため any を使う
  const selectRef = useRef<any>(null);

  const defaultOption = (): SelectItem | null => {
    return options.find(item => item.value === defaultCompanyId) || null;
  };

  useEffect(() => {
    setSelectedOption(defaultOption());
    // eslint-disable-next-line react-hooks/exhaustive-deps -- react-hooks ルール有効化に伴う既存実装の暫定許容（別途対応）
  }, [defaultCompanyId, options]);

  const handleChangeValue = (data: SelectItem | null) => {
    setSelectedOption(data);
  };

  // 事業者を選択時にEnter押すとPOSTリクエストが飛んでしまうため、そうならないようにEnter押下時の処理を追加
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const { select } = selectRef.current;
    const { focusedOption } = select.state;

    switch (event.key) {
      case 'Enter':
        event.preventDefault();
        if (!select.props.menuIsOpen) {
          selectRef.current.setState({
            menuIsOpen: true,
          });
          break;
        } else {
          if (!focusedOption) return;
          if (select.isComposing) return;
          select.selectOption(focusedOption);
          break;
        }
    }
  };

  return (
    <Select
      value={selectedOption}
      name={inputName}
      className={className}
      ref={selectRef}
      isClearable={true}
      onChange={handleChangeValue}
      onKeyDown={onKeyDown}
      options={options}
      noOptionsMessage={() => '選択可能な銘柄がありません。'}
      placeholder={placeholder || ''}
    />
  );
}
